import type { OfficeMessage } from './types';

export const orderOfficeMessages = (messages: OfficeMessage[]): OfficeMessage[] =>
  messages
    .map((message, index) => ({ message, index }))
    .sort((left, right) => {
      const leftSequence = left.message.sequence;
      const rightSequence = right.message.sequence;
      if (typeof leftSequence === 'number' && typeof rightSequence === 'number' && leftSequence !== rightSequence) {
        return leftSequence - rightSequence;
      }
      if (left.message.createdAt !== right.message.createdAt) {
        return left.message.createdAt - right.message.createdAt;
      }
      if (left.message.turnId && left.message.turnId === right.message.turnId && left.message.role !== right.message.role) {
        return left.message.role === 'user' ? -1 : 1;
      }
      return left.index - right.index;
    })
    .map(item => item.message);
